import { render, staticRenderFns } from "./StudentSettings.vue?vue&type=template&id=d4eb4196&"
import script from "./StudentSettings.vue?vue&type=script&lang=js&"
export * from "./StudentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports